const url = '/wp-admin/admin-ajax.php';
import _ from 'lodash';
const action = 'wish_list_ajax_response';
let wishlistUnavailable = false;
let listRequest = 0;
const markUnavailable = () => { wishlistUnavailable = true; };

$(function () {
  // gather wish list buttons
  $('.product-like').each(function (i, button) {
    let $button = $(button);
    let modelId = $button.data('model-id');

    // add class active if model is in wish list
    isInWishList(modelId).then(wished => {
      $button.attr('aria-pressed', String(wished));
      if (wished) $button.find('svg').addClass('!fill-black');
    }).catch(markUnavailable);

    // add click event listener
    $button.off('click').on('click', () => {
      let fct = $button.find('svg').hasClass('!fill-black') ? 'remove' : 'add';
      manageWishList(fct, modelId, $button);
    });
  });

  // Delegation also covers freshly rendered items: deletion is available immediately.
  $('#heartDropdownMenu').on('click', '.deleteWishList', onClickDropdownItem);
  generateList();

  $('#heartDropdown').on('click', function (e) {
    e.preventDefault();
    if (wishlistUnavailable) generateList();
    const open = $('#heartDropdownMenu').toggleClass('hidden').hasClass('hidden') === false;
    $(this).attr('aria-expanded', String(open));
    $('#heartDropdown svg').toggleClass('fill-none !fill-linen-light');
  });

  // Close heartDropdownMenu when clicking outside
  $(document).on('mousedown touchstart', function (e) {
    const $menu = $('#heartDropdownMenu');
    const $dropdown = $('#heartDropdown');
    if (!$menu.hasClass('hidden')) {
      // If click is outside menu and dropdown button
      if (
        !$menu.is(e.target) &&
        $menu.has(e.target).length === 0 &&
        !$dropdown.is(e.target) &&
        $dropdown.has(e.target).length === 0
      ) {
        $menu.addClass('hidden');
        $dropdown.attr('aria-expanded', 'false');
        $dropdown.find('svg').removeClass('!fill-linen-light').addClass('fill-none');
      }
    }
  });
});

/**
 * Remove item from wish list and close menu
 * @param {MouseEvent} e
 * @returns {void}
 */
function onClickDropdownItem(e) {
  e.preventDefault();
  e.stopPropagation();

  let modelId = $(e.target).closest('.wishlist-item').data('model-id');

  const button = $(e.currentTarget).prop('disabled', true);
  manageWishList('remove', modelId, $(`.product-like[data-model-id=${modelId}]`))
    .finally(() => button.prop('disabled', false));
}

/**
 * Manage wish list actions
 * @param {string} action - the action to execute
 * @param {number} model - id of the model to add or remove from list
 * @param {jQuery} trigger - the button on witch we want to toggle class active
 * @returns {void}
 */
function manageWishList(action, model, trigger) {
  trigger.prop('disabled', true);
  return editWishList(action, model).then(() => {
    trigger.attr('aria-pressed', String(action === 'add'));
    action === 'add'
      ? trigger.find('svg').addClass('!fill-black')
      : trigger.find('svg').removeClass('!fill-black');
    return generateList();
  }).catch(showWishlistError).finally(() => trigger.prop('disabled', false));
}

/**
 * Fetch wish list and populate list in dropdown menu in header
 * @return {void}
 */
function generateList() {
  const request = ++listRequest;
  return getWishList().then(list => {
    if (request !== listRequest) return;
    wishlistUnavailable = false;
    // add a badge to the heart icon with number of items in wish list
    let $badge = $('#heartDropdown').find('.wishlist-badge');
    if (list.length > 0) {
      if ($badge.length === 0) {
        $badge = $('<span></span>')
          .addClass(
            'wishlist-badge font-display absolute -top-2 -right-1 bg-linen-light text-back text-[12px] font-bold leading-none w-4 h-4 rounded-full flex items-center justify-center',
          )
          .appendTo($('#heartDropdown').css('position', 'relative'));
      }
      $badge.text(list.length);
    } else {
      $badge.remove();
    }
    
    const menuIds = ['heartDropdownMenu'];

    menuIds.forEach(id => {
      let menu = $(`#${id}`);

      // empty the menu so we can easily populate it
      menu.empty();

      // Load wishlist item template from DOM
      let tplHtml = $('#wishlist-item-template').html();
      tplHtml = typeof tplHtml === 'string' ? tplHtml.trim() : '';
      const wishlistItemTemplate = _.template(tplHtml);
      // Render all items in one template pass
      let $dropdownItems = $(wishlistItemTemplate({ items: list }));
      menu.append($dropdownItems);

    });
  }).catch(showWishlistError);
}

// Preserve the current favorites when a request fails (including page-navigation aborts).
// The next menu opening retries the background read.
function showWishlistError() {
  wishlistUnavailable = true;
  const message = document.documentElement.lang.startsWith('nl')
    ? 'Favorieten zijn tijdelijk niet beschikbaar. Probeer opnieuw.'
    : 'Les favoris sont momentanément indisponibles. Réessayez.';
  const menu = $('#heartDropdownMenu');
  menu.find('.wishlist-status').remove();
  $('<p>').addClass('wishlist-status p-3 text-sm').attr('role', 'status').text(message).appendTo(menu);
}

/**
 * Add or remove model from favorites
 * @param {string} fct - Action to trigger (add, remove, is_favorite, fetch_all)
 * @param {number} id - The model id
 * @return {Promise<any>}
 */
function editWishList(fct, id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      data: { action, fct, id },
      method: 'POST',
      dataType: 'json',
      success: () => resolve(),
      error: error => reject(error),
    });
  });
}

/**
 * Check if model is in wish list
 * @param {number} id - The model id
 * @returns {Promise<boolean>}
 */
function isInWishList(id) {
  let fct = 'is_favorite';
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      data: { action, fct, id },
      method: 'POST',
      dataType: 'json',
      success: data => resolve(data.is_favorite),
      error: error => reject(error),
    });
  });
}

/**
 * Get user's wish list
 * @returns {Promise<[]>}
 */
function getWishList() {
  let fct = 'fetch_all';
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      data: { action, fct },
      method: 'POST',
      dataType: 'json',
      success: data => resolve(data.wishlist),
      error: error => reject(error),
    });
  });
}
